document.addEventListener('DOMContentLoaded', function () {
  // Adds a working "Eliminar" (remove) button to each line item inside the
  // mini-cart drawer (snippets/ldn-cart-drawer.liquid), without touching the
  // existing ludino-theme.js cart-drawer code. Works by watching the drawer's
  // items container for re-renders and decorating each new row with a button
  // wired to Shopify's /cart/change.js endpoint.
  var drawer = document.querySelector('[data-ldn-cart-drawer]');
  if (!drawer) return;

  var itemsEl = drawer.querySelector('[data-ldn-cart-items]');
  if (!itemsEl) return;

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function formatMoney(cents, currency) {
    try {
      return (cents / 100).toLocaleString('es-CL', { style: 'currency', currency: currency || 'CLP', maximumFractionDigits: 0 });
    } catch (e) {
      return '$' + Math.round(cents / 100);
    }
  }

  function updateCountBadges(count) {
    document.querySelectorAll('[data-ldn-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function removeLine(key, lineEl) {
    if (!key || (lineEl && lineEl.classList.contains('is-removing'))) return;
    if (lineEl) lineEl.classList.add('is-removing');

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        updateCountBadges(cart.item_count);

        var footEl = drawer.querySelector('[data-ldn-cart-foot]');
        var subtotalEl = drawer.querySelector('[data-ldn-cart-subtotal]');

        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<div class="ldn-cartdrawer__empty">Tu carrito está vacío.</div>';
          if (footEl) footEl.style.display = 'none';
          return;
        }

        if (lineEl && lineEl.parentNode) lineEl.parentNode.removeChild(lineEl);
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
      })
      .catch(function () {
        if (lineEl) lineEl.classList.remove('is-removing');
      });
  }

  function buildRemoveButton(item) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ldn-cartitem__remove';
    btn.setAttribute('data-ldn-cart-remove', item.key);
    btn.setAttribute('aria-label', 'Eliminar ' + escapeHtml(item.product_title || 'producto') + ' del carrito');
    btn.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
        '<path d="M4 4l12 12M16 4 4 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path>' +
      '</svg><span>Eliminar</span>';
    return btn;
  }

  // Whenever the drawer's item list re-renders (on open, or after adding a
  // product), match the freshly rendered rows to the live cart by position
  // and append a remove button + line key to any row that doesn't have one yet.
  function decorate() {
    var rows = itemsEl.querySelectorAll('.ldn-cartitem');
    if (!rows.length) return;

    fetchCart().then(function (cart) {
      if (!cart.items || rows.length !== cart.items.length) return;
      rows.forEach(function (row, i) {
        if (row.hasAttribute('data-ldn-cart-line')) return;
        var item = cart.items[i];
        row.setAttribute('data-ldn-cart-line', item.key);
        var rowInner = row.querySelector('.ldn-cartitem__row');
        if (!rowInner || rowInner.querySelector('[data-ldn-cart-remove]')) return;
        rowInner.appendChild(buildRemoveButton(item));
      });
    }).catch(function () {});
  }

  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ldn-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    removeLine(btn.getAttribute('data-ldn-cart-remove'), btn.closest('[data-ldn-cart-line]'));
  });

  var observer = new MutationObserver(function () { decorate(); });
  observer.observe(itemsEl, { childList: true });

  // In case the drawer already has items rendered before this script runs.
  decorate();
});
